import { ApiService } from './api.service';
import { Empty } from '@/models/core/empty';
import { Student } from '@/models/student/student';
import { EventCreateRequest } from '@/models/jgrow/event-param';
import { Event, UpdateEventsStudentsResult } from '@/models/jgrow/event';
import { EventForList } from '@/models/jgrow/event-for-list';
import { EventProgressResult } from '@/models/jgrow/event-progress';

class JgrowEventService extends ApiService {
  constructor() {
    super();
  }

  /**
   * JGROW - イベント作成
   */
  createEvent(params: EventCreateRequest) {
    return this.post(Empty, `/jgrow/event`, params);
  }

  /**
   * JGROW - イベント更新
   */
  updateEvent(eventID: number, params: EventCreateRequest) {
    return this.put(Empty, `/jgrow/event/${eventID}`, params);
  }

  /**
   * JGROW - イベント取得
   */
  getEvent(eventID: number): Promise<Event> {
    return this.get(Event, `/jgrow/event/${eventID}`, {});
  }

  /**
   * JGROW - 全イベント取得
   */
  getEvents(): Promise<EventForList[]> {
    return this.getList(EventForList, `/jgrow/event`, {});
  }

  /**
   * JGROW - イベント進捗
   */
  getProgress(eventID: number): Promise<EventProgressResult> {
    return this.get(EventProgressResult, `/jgrow/event/${eventID}/progress`, {});
  }

  /**
   * 進捗ダウンロード
   * @param evalSettingID
   */
  downloadProgress(eventID: number): Promise<Blob> {
    return this.downloadFile(`/jgrow/event/${eventID}/download`, {});
  }

  /**
   * Get evaluatee students
   */
  getEventStudents(eventID: number): Promise<Student[]> {
    return this.getList(Student, `/jgrow/event/${eventID}/students`, {});
  }

  /**
   * イベント削除
   */
  deleteEvent(id: number): Promise<Empty> {
    return this.delete(`/jgrow/event/${id}`, {});
  }

  /**
   * 受検者割り当て情報更新
   * @param eventID
   */
  updateExamineeStudents(eventID: number): Promise<UpdateEventsStudentsResult> {
    return this.put(UpdateEventsStudentsResult, `/jgrow/event/${eventID}/students`, {});
  }
}

export const jgrowEventService = new JgrowEventService();
